module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tag"
  }, [(_vm.isShowControl) ? _c('div', {
    staticClass: "left",
    on: {
      "click": function($event) {
        return _vm.scrollTags('left')
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, _vm._l((_vm.menu), function(v, k) {
    return _c('div', {
      key: k,
      staticClass: "tag-item",
      class: {
        'tag-item-active': _vm.activeMenu.name === v.name ? true : false
      },
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: v.name
          })
        }
      }
    }, [(_vm.activeMenu.name === v.name) ? _c('span', {
      staticClass: "active-flag"
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "tag-title"
    }, [_vm._v(_vm._s(v.meta.title))]), _vm._v(" "), (_vm.menu.length > 1) ? _c('span', {
      staticClass: "close-tag",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.close(v, k)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-close"
    })]) : _vm._e()])
  }), 0), _vm._v(" "), (_vm.isShowControl) ? _c('div', {
    staticClass: "right",
    on: {
      "click": function($event) {
        return _vm.scrollTags('right')
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-right"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-76763617!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/app-tags.vue
// module id = 1406
// module chunks = 129